import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { BookingLinkInvitee } from '@/modules/bookinglink/models/BookingLinkInvitee';

export class BookingLink extends BaseModel {
  id?: number;
  referralId?: number;
  eventTypeUuid?: string;
  createdByUserId?: number;
  url?: string | null;
  invitees: BookingLinkInvitee[];

  constructor(model: Partial<BookingLink> = {}) {
    super(model);

    this.id = model.id;
    this.referralId = model.referralId;
    this.eventTypeUuid = model.eventTypeUuid;
    this.createdByUserId = model.createdByUserId;
    this.url = model.url ?? null;
    this.invitees = BookingLinkInvitee.mapModels(model.invitees);
  }
}
